module.exports = __webpack_public_path__ + "img/option-life.0770f9c.png";